import axios from 'axios';

export const ipAsync = async () => {
    const { data } = await axios({
        method: "GET",
        url: "https://api.ipgeolocationapi.com/geolocate", //"https://api.ipify.org/?format=json",
    });
    console.log(data);
    return data;
    // return data.ip;
    // return "103.251.215.231";
}

const getBrowser = () => {
    var ua = window.navigator.userAgent;
    var b;
    if (ua.indexOf("Opera") !== -1) {
        b = "Opera";
    }

    if (ua.indexOf("Firefox") !== -1 && ua.indexOf("Opera") === -1) {
        b = "Firefox";
    }

    if (ua.indexOf("Chrome") !== -1) {
        b = "Chrome";
    }

    if (ua.indexOf("Safari") !== -1 && ua.indexOf("Chrome") === -1) {
        b = "Safari";
    }

    if (ua.indexOf("MSIE") !== -1 && (ua.indexOf("Opera") === -1 && ua.indexOf("Trident") === -1)) {
        // b = "MSIE";
        b = "Internet Explorer";
    }

    if (ua.indexOf("Trident") !== -1) {
        // b = "Trident";
        b = "Internet Explorer";
    }

    var version = ua.match(b + "[ /]+[0-9]+(.[0-9]+)*")[0];

    return version;
}

export const addUserDetails = async (user) => {
    // const ipDetails = await ipAsync()
    const browser = getBrowser()
    const device = window.navigator.platform;
    const date = Date.now()
    const country = 'India'// ipDetails.name;
    const state = "Gujrat";
    return {
        ...user,
        ipaddress: "103.251.215.231",
        browser,
        device,
        date,
        country,
        state,
    }
}